/*!
FullCalendar Adaptive Plugin v6.1.15
Docs & License: https://fullcalendar.io/docs/print
(c) 2024 Adam Shaw
*/ FullCalendar.Adaptive = function(e, t, n, i, r) {
    "use strict";
    function a(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    var l = a(n);
    i.config.COLLAPSIBLE_WIDTH_THRESHOLD = 1200;
    let c = [], f = [];
    function o() {
        for (let e of c)e.emitter.trigger("_beforeprint");
        r.flushSync(()=>{
            f.push(function() {
                let e = i.findElements(document.body, ".fc-scrollgrid");
                return e.forEach(u), ()=>e.forEach(s);
            }());
        });
    }
    function d() {
        for (let e of c)e.emitter.trigger("_afterprint");
        r.flushSync(()=>{
            for(; f.length;)f.shift()();
        });
    }
    function u(e) {
        let t = e.getBoundingClientRect().width;
        (!e.classList.contains("fc-scrollgrid-collapsible") || t < i.config.COLLAPSIBLE_WIDTH_THRESHOLD) && (e.style.width = t + "px");
    }
    function s(e) {
        e.style.width = "";
    }
    i.injectStyles(".fc .fc-event,.fc .fc-scrollgrid table tr{-moz-column-break-inside:avoid;break-inside:avoid}.fc-media-print{display:block;max-width:100%}.fc-media-print .fc-bg-event,.fc-media-print .fc-non-business,.fc-media-print .fc-timegrid-axis-chunk,.fc-media-print .fc-timegrid-slots,.fc-media-print .fc-timeline-slots{display:none}.fc-media-print .fc-h-event,.fc-media-print .fc-toolbar button,.fc-media-print .fc-v-event{background:#fff!important;color:#000!important}.fc-media-print .fc-event,.fc-media-print .fc-event-main{color:#000!important}.fc-media-print .fc-timegrid-event{margin:.5em 0}");
    var m = t.createPlugin({
        name: "@fullcalendar/adaptive",
        premiumReleaseDate: "2024-07-12",
        deps: [
            l.default
        ],
        contextInit: function(e) {
            c.length || (window.addEventListener("beforeprint", o), window.addEventListener("afterprint", d)), c.push(e), e.calendarApi.on("_unmount", ()=>{
                i.removeExact(c, e), c.length || (window.removeEventListener("beforeprint", o), window.removeEventListener("afterprint", d));
            });
        }
    });
    return t.globalPlugins.push(m), e.default = m, Object.defineProperty(e, "__esModule", {
        value: !0
    }), e;
}({}, FullCalendar, FullCalendar.PremiumCommon, FullCalendar.Internal, FullCalendar.Preact);

//# sourceMappingURL=index.0a21f015.js.map
